export const AppColors = {
  primary: {
    100: "#f0eee6",
    200: "#bcaf8c",
    300: "#6D5205",
    400: "#634b05",
    500: "#3c2d03",
    600: "#323232",
  },
  secondary: {
    100: "#e6e9f0",
    200: "#8c98bc",
    300: "#05206D",
    400: "#051d63",
    450: "#0E0E46",
    500: "#03123c",
    600: "#101828",
  },
  success: {
    100: "#ECFDF3", // Lightest success green (backgrounds)
    200: "#D1FAE5",
    300: "#A7F3D0",
    400: "#6EE7B7",
    500: "#12B76A", // Vibrant success green
    600: "#027A48", // Deep green
    700: "#065F46",
    800: "#064E3B",
    900: "#022C22", // Darkest green
  },
  neutral: {
    120: "#F7F7FD",
    115: "#F9F9F9", // New addition
    110: "#FEFEFE",
    105: "#F7F7F7", // New addition
    100: "#ffffff",
    90: "#FAFAFA",
    85: "#DCDCEB",
    82: "#E6E9F0",
    80: "#F5F5F5",
    79: "#F4F4F4",
    78: "#FBFBFB",
    75: "#D9D9D9",
    73: "#D5D7DA",
    70: "#E5E5E5",
    68: "#E6E6E6", // ✅ Added here
    65: "#E5E5E7",
    63: "#E4E7EC",
    60: "#D4D4D4",
    55: "#EDEDED",
    50: "#A3A3A3",
    49: "#8A909A", // Keeping this distinct from 50
    48: "#999999", // Preserved as requested
    46: "#8B8C8C",
    45: "#868686", // Adjusted from #999999 to avoid duplication
    43: "#535862",
    40: "#737373",
    35: "#565656",
    30: "#525252",
    20: "#404040",
    10: "#262626",
    dark: "#1a1918",
  },
  text: {
    default: "#323232",
    light: "#494949",
    second: "#6A6A6A",
    emphasis: "#475467", // New addition
  },
  error: {
    default: "#CB2214",
    dark: "#900B09",
    light: "#EE6055",
  },
  gradient: {
    primary: "linear-gradient(#05206D, #6D5205)",
    secondary: "linear-gradient(to right, #73570C, #B98E2F, #73570C)",
    mission: "linear-gradient(270deg, #03123C -2.94%, #3C2D03 100%)",
  },
  shadows: {
    right: "4px 0px 17px 4px rgba(0,0,0,0.1)",
    bottom: "0px 10px 12px -4px rgba(0,0,0,0.12)", // Enhanced bottom shadow for more depth
  },
};
